module.exports = "/static/assets/e0b5ccb83cc149fdbeaca13a0693b9ed.png";